// R109 #b — "The office asked you for more info". When someone on the Issues
// board sends a question with the "In the app" channel, the person it's for
// sees this pill on whatever page they land on; each question opens the same
// answer link a text / Slack / email would carry (text + photos, no login).
import { bottomBarClearance } from '../lib/bottomBars';

const esc = (s: any) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));

let timer: number | undefined;

// R114 fix2: at phone width this pill sat on the inspection report's sticky
// "Edit scoring · manual checklist" bar — it now lifts above any bottom action
// bar under it (shared/lib/bottomBars), re-placed as the page scrolls/redraws.
function placeAsk(): void {
  const pill = document.getElementById('info-ask-pill');
  if (!pill) return;
  // a shared company login keeps its "switch person" chip in this corner — sit above it
  const base = document.getElementById('shared-actor-chip') ? 64 : 16;
  pill.style.bottom = `${Math.max(base, bottomBarClearance(pill, base))}px`;
}
let placeBound = false;
function bindPlacement(): void {
  if (placeBound) return;
  placeBound = true;
  let raf = 0;
  const soon = () => { if (!raf) raf = window.requestAnimationFrame(() => { raf = 0; placeAsk(); }); };
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  document.addEventListener('click', soon);
  try { new MutationObserver(soon).observe(document.body, { childList: true, subtree: true }); } catch { /* scroll / resize still re-place it */ }
}

export function mountInfoAskPill(): void {
  const role = (() => { try { return sessionStorage.getItem('userRole') || ''; } catch { return ''; } })();
  if (role === 'owner' || role === 'accounting') return;
  const check = async () => {
    const j = await fetch('/api/assetops/issue-info/requests/mine').then(r => r.ok ? r.json() : null).catch(() => null);
    const list: any[] = (j && j.requests) || [];
    let pill = document.getElementById('info-ask-pill');
    if (!list.length) { pill?.remove(); return; }
    if (!pill) {
      pill = document.createElement('div');
      pill.id = 'info-ask-pill';
      pill.style.cssText = 'position:fixed; left:16px; bottom:16px; z-index:800; max-width:min(380px, calc(100vw - 32px)); font-size:13px;';
      document.body.appendChild(pill);
    }
    const open = pill.dataset.open === '1';
    pill.innerHTML = `
      <button data-iap-toggle style="display:flex; align-items:center; gap:8px; padding:10px 14px; border-radius:999px; border:1px solid #93c5fd; background:#eff6ff; color:#1d4ed8; font-weight:700; cursor:pointer; box-shadow:0 6px 20px rgba(15,23,42,.15);">❓ The office asked you ${list.length === 1 ? 'a question' : `${list.length} questions`}</button>
      <div data-iap-list style="display:${open ? 'block' : 'none'}; margin-top:8px; background:var(--card,#fff); border:1px solid var(--border,#e2e8f0); border-radius:12px; box-shadow:0 8px 28px rgba(15,23,42,.18); padding:6px; max-height:50vh; overflow:auto;">
        ${list.map(q => `<a href="${esc(q.url)}" target="_blank" rel="noopener" style="display:block; padding:9px 10px; border-radius:8px; text-decoration:none; color:inherit; border-bottom:1px solid var(--border,#e2e8f0);">
          <div style="font-weight:700;">${esc(q.title)}</div>
          <div style="color:var(--text-muted,#64748b); font-size:12px;">${esc(q.listing_name || '')}${q.asked_by ? ` · from ${esc(q.asked_by)}` : ''}</div>
          <div style="margin-top:3px;">“${esc(String(q.question || '').slice(0, 160))}”</div>
          <div style="margin-top:4px; color:#1d4ed8; font-weight:600;">Answer →</div>
        </a>`).join('')}
      </div>`;
    pill.querySelector('[data-iap-toggle]')?.addEventListener('click', () => {
      const l = pill!.querySelector('[data-iap-list]') as HTMLElement;
      const show = l.style.display === 'none';
      l.style.display = show ? 'block' : 'none';
      pill!.dataset.open = show ? '1' : '';
    });
    placeAsk();
    bindPlacement();
  };
  void check();
  if (timer) window.clearInterval(timer);
  timer = window.setInterval(() => { if (!document.hidden) void check(); }, 5 * 60 * 1000);
}
